export const PersianCharecterRegex = /^[\u0600-\u06FF\s]+$/
export const PersianCharecterWithNumberRegex = /^[\u0600-\u06FF\s\d]+$/
export const IntegerNumberRegex = /^\d+$/
export const PriceRegex = /^[-,0-9]+$/
export const PersianMobileNumberRegex = /^09(0[1-5]|[1 3]\d|2[0-2]|98)\d{7}$/
export const PersianTelephoneNumberRegex = /^0([1-8])\d{9}$/
export const EnglishCharecterRegex = /^[a-zA-Z0-9?><;,{}[\]\-_+=.!@#$%\\^&*|']*$/
